<div class="pages-body flex flex-column cust-height">
    <div class="align-self-center mt-cust mb-auto" style="width: 350px;">
        <div class="pages-panel card flex flex-column">                   
            <div class="col-12 text-center">
                <img src="../../../assets/layout/images/documalis_logo.png">
            </div>
            <div class="col-12 text-center">
                <span>{{'Expired' | translate}}</span>
            </div>
            <form (ngSubmit)="onSubmit()" id="form">
                <div class="col-12 text-center">
                    <button type="submit" class="p-button p-component p-button-text-icon-left">
                        <span class="p-button-icon-left ui-c pi pi-user"></span>
                        <span class="p-button-text ui-c">{{'Connect' | translate}}</span>
                </button>
                </div>
            </form>
        </div>
    </div>
</div>